import { render, staticRenderFns } from "./main_view.vue?vue&type=template&id=91f16d7a&"
import script from "./main_view.vue?vue&type=script&lang=js&"
export * from "./main_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports